<script>
import { defineComponent } from 'vue'
import AdvancedThumbnailImpl from './advanced-thumbnail-impl.vue'

export default defineComponent({
    name: 'advanced-thumbnail',
    components: { AdvancedThumbnailImpl },
    props: {
        alt: String,
        thumb: String,
        backgroundType: String,

        aspectRatio: Number,
        elements: {
            type: Array,
            default: () => []
        },
        margin: {
            type: Boolean,
            default: true
        },
        minWidthForStateAndIcon: Boolean,
        grid: String,
        previewHeight: Number
    },
    computed: {
        hrefContainerStyle() {
            const style = {};
            if (this.aspectRatio != undefined) {
                style['--thumbnail-aspect-ratio'] = this.aspectRatio;
                style['margin-top'] = 'auto';
                style['margin-bottom'] = 'auto';
            }
            if (this.elements?.length > 0) {
                style['--num-thumbnail-elements'] = this.elements.length;
            }
            switch (this.grid) {
                default:
                case '2cols':
                    if (this.previewHeight === 60) {
                        style['--thumbnail-width-max-view'] = 280;
                    } else {
                        style['--thumbnail-width-max-view'] = 450;
                    }
                    break;
                case '3cols':
                    if (this.previewHeight === 60) {
                        style['--thumbnail-width-max-view'] = 170;
                    } else {
                        style['--thumbnail-width-max-view'] = 200;
                    }
                    break;
            }
            return style;
        }
    }
})
</script>

<template>
    <a :aria-label="alt"
       :class="{'advanced-thumbnail-link-margin': margin && !elements.length}"
       :style="hrefContainerStyle"
       class="advanced-thumbnail-href-container"
       @click="$emit('click', $event)">

        <div v-if="thumb && elements.length"
             class="thumbnail-overflow-container">
            <div class="thumbnail-elements-container">
                <template v-for="(element, index) in elements">
                    <advanced-thumbnail-impl
                        :key="index"
                        :alt="element.name"
                        :backgroundType="backgroundType"
                        :thumb="element.background_image"
                        :min-width-for-state-and-icon="minWidthForStateAndIcon"/>
                </template>
            </div>
        </div>

        <advanced-thumbnail-impl v-else
                                 :alt="alt"
                                 :backgroundType="backgroundType"
                                 :thumb="thumb"
                                 :min-width-for-state-and-icon="minWidthForStateAndIcon">
            <slot />
        </advanced-thumbnail-impl>
    </a>
</template>
